import React from 'react';

import { Stack, Typography } from '@mui/material';

import { styles } from './styles';

import type { ReactNode } from 'react';

export interface AdminPageFrameProps {
  /** The page's heading, also what its breadcrumb says. */
  title: string;
  /** The page's main action (a Scout `Button`), top right beside the title. */
  primaryAction?: ReactNode;
  /** One line under the title saying what the page is for. */
  description?: ReactNode;
  children: ReactNode;
  /** The root's id; the heading gets `<id>-title`. */
  id?: string;
}

/**
 * The admin page header and gutter, as /admin/jobs draws them: a 38px heading with the primary
 * action on its right, content below.
 */
const AdminPageFrame = ({
  children,
  description,
  id,
  primaryAction,
  title
}: AdminPageFrameProps) => (
  <Stack id={id} sx={styles.root}>
    <Stack sx={styles.header}>
      <Stack sx={styles.titleRow}>
        <Typography component="h1" id={id ? `${id}-title` : undefined} sx={styles.title}>
          {title}
        </Typography>
        {primaryAction ? <Stack sx={styles.actions}>{primaryAction}</Stack> : null}
      </Stack>
      {description ? (
        <Typography component="div" sx={styles.description}>
          {description}
        </Typography>
      ) : null}
    </Stack>
    {children}
  </Stack>
);

export default AdminPageFrame;
